import { render, staticRenderFns } from "./ICMarketingBlog.vue?vue&type=template&id=5997d104"
import script from "./ICMarketingBlog.vue?vue&type=script&lang=js"
export * from "./ICMarketingBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports